/* LensAdvisor homepage — Rx modal navigation + scroll-reveal.
   Shared across the split home sections (hero, merchant mock, pullquote, etc.).
   Safe to load on any page: all logic bails cleanly if no .la-home wrappers exist. */

(function () {
  const init = () => {
    const roots = document.querySelectorAll('.la-home');
    if (!roots.length) return;

    // --- Rx modal (only one lives in the DOM, owned by the merchant-mock section) ---
    const modal = document.getElementById('la-rx-modal');
    if (modal && !modal.dataset.laRxReady) {
      modal.dataset.laRxReady = '1';
      const screens = modal.querySelectorAll('.la-rx-screen');
      const pips = modal.querySelectorAll('.la-rx-stepbar span');
      const backBtn = modal.querySelector('[data-la-rx-back]');
      const progress = modal.querySelector('[data-la-rx-progress]');
      const body = modal.querySelector('.la-rx-body');
      let history = ['type'];

      const screenFor = (step) => modal.querySelector('.la-rx-screen[data-step="' + step + '"]');

      const render = () => {
        const step = history[history.length - 1];
        const screen = screenFor(step);
        if (!screen) return;
        screens.forEach((s) => { s.hidden = true; });
        screen.hidden = false;
        const pipNum = parseInt(screen.dataset.pip || '1', 10);
        pips.forEach((p, idx) => {
          const n = idx + 1;
          if (n < pipNum) { p.setAttribute('data-done', ''); p.removeAttribute('data-active'); }
          else if (n === pipNum) { p.setAttribute('data-active', ''); p.removeAttribute('data-done'); }
          else { p.removeAttribute('data-active'); p.removeAttribute('data-done'); }
        });
        if (progress) progress.textContent = 'Step ' + String(pipNum).padStart(2, '0') + ' of 07';
        if (backBtn) backBtn.hidden = history.length <= 1;
        if (body) body.scrollTop = 0;
        const focusTarget = screen.querySelector('.la-rx-opt, input, .la-rx-pill, .la-rx-continue');
        if (focusTarget) setTimeout(() => focusTarget.focus(), 60);
      };

      const advance = (next) => {
        if (!next || !screenFor(next)) return;
        history.push(next);
        render();
      };

      const openers = document.querySelectorAll('[data-la-open-rx]');
      const closers = modal.querySelectorAll('[data-la-close-rx]');
      const openModal = () => {
        history = ['type'];
        render();
        modal.hidden = false;
        document.body.classList.add('la-rx-open');
      };
      const closeModal = () => {
        modal.hidden = true;
        document.body.classList.remove('la-rx-open');
      };

      openers.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openModal(); }));
      closers.forEach((el) => el.addEventListener('click', closeModal));
      modal.querySelectorAll('[data-next]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          advance(el.dataset.next);
        });
      });
      if (backBtn) backBtn.addEventListener('click', () => {
        if (history.length > 1) { history.pop(); render(); }
      });

      modal.querySelectorAll('.la-rx-optgroup').forEach((group) => {
        group.querySelectorAll('.la-rx-pill').forEach((pill) => {
          pill.addEventListener('click', () => {
            group.querySelectorAll('.la-rx-pill').forEach((p) => p.classList.remove('la-rx-pill-active'));
            pill.classList.add('la-rx-pill-active');
          });
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    // --- Scroll reveal (skip the absolute-positioned assembly cards) ---
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = [];
    roots.forEach((root) => {
      root.querySelectorAll('.la-sec-head, .la-inc-card, .la-pull p, .la-close-inner > div').forEach((el) => {
        if (!el.dataset.laReveal) {
          el.dataset.laReveal = '1';
          targets.push(el);
        }
      });
    });
    if (!targets.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.animate(
          [
            { opacity: 0, transform: 'translateY(18px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 650, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'both' }
        );
        io.unobserve(e.target);
      });
    }, { threshold: 0.12 });
    targets.forEach((el) => { el.style.opacity = '0'; io.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme-editor section events so new sections wire up.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
